import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class ConfigService {
  private config: Object = null;
  private apiConfig: Object = null;
  private env: Object = null;

  constructor(private http: Http) {}

  private mapMilkwayStage(stage: string) {
    switch (stage) {
      case 'ycy':
        return 'dev1';
      case 'glenn':
        return 'dev2';
      case 'production':
        return 'prod';
      default:
        return stage; // same stage name across Kalinda/ MilkyWay
    }
  }

  /**
   * Use to get the data found in the second file (config file)
   */
  public getConfig(key: any) {
    return this.config[key];
  }

  /**
   * Use to get api for given service
   */
  public getApiConfig(key: any) {
    return this.apiConfig[key];
  }

  /**
   * Use to get the data found in the first file (env file)
   */
  public getEnv(key: any) {
    return this.env[key];
  }

  /**
   * @deprecated - future services should maintain their own api endpoint
   * Helper method to return the url for API calls
   */
  public getBaseUrl() {
    return (
      this.getConfig('host') +
      '/' +
      this.getApiConfig('dashboardAPI') +
      '/' +
      this.getConfig('stage') +
      '/' +
      this.getConfig('appName') +
      '/' +
      this.getConfig('version')
    );
  }

  /**
   * Get the notification api endpoint
   */

  public getNotifcationUrl() {
    return (
      this.getConfig('host') +
      '/' +
      this.getApiConfig('notificationsAPI') +
      '/' +
      this.getConfig('stage')
    );
  }

  public getPrecoolUrl() {
    return (
      this.getConfig('host') +
      '/' +
      this.getApiConfig('precoolAPI') +
      '/' +
      this.mapMilkwayStage(this.getConfig('stage'))
    );
  }

  public getRoomConsumptionUrl() {
    return this.getConfig('host') + '/' + 'room-energy-consumption' + '/' + this.getConfig('stage');
  }

  public getRoomTemplateUrl() {
    return (
      this.getConfig('host') +
      '/' +
      this.getApiConfig('roomTemplateAPI') +
      '/' +
      this.getConfig('stage')
    );
  }

  public getAutosetUrl() {
    return (
      this.getConfig('host') + '/' + this.getApiConfig('autosetAPI') + '/' + this.getConfig('stage')
    );
  }

  public getSettingsUrl() {
    return (
      this.getConfig('host') +
      '/' +
      this.getApiConfig('settingsAPI') +
      '/' +
      this.getConfig('stage')
    );
  }

 public getSettingsV2Url() {
    return (
      this.getConfig('host') +
      '/' +
      this.getApiConfig('settingsAPIV2') +
      '/' +
      this.mapMilkwayStage(this.getConfig('stage'))
    );
  }

  public getIotUrl() {
    return (
      this.getConfig('host') + '/' + this.getApiConfig('iotAPI') + '/' + this.getConfig('stage')
    );
  }

  public getRoomUrl() {
    return (
      this.getConfig('host') + '/' + this.getApiConfig('roomAPI') + '/' + this.getConfig('stage')
    );
  }

  getDashBoardHealthUrl(): any {
    return (
      this.getConfig('host') +
      '/' +
      this.getApiConfig('dashboardHealthAPI') +
      '/' +
      this.getConfig('stage')
    );
  }

  getNodeUrl(): any {
    return (
      this.getConfig('host') + '/' + this.getApiConfig('nodeAPI') + '/' + this.getConfig('stage')
    );
  }

  getNodeDataUrl(): any {
    return (
      this.getConfig('host') +
      '/' +
      this.getApiConfig('nodeDataAPI') +
      '/' +
      this.getConfig('stage')
    );
  }

  getGatewayUrl(): any {
    return (
      this.getConfig('host') + '/' + this.getApiConfig('gatewayAPI') + '/' + this.getConfig('stage')
    );
  }

  getUsersUrl(): any {
    return (
      this.getConfig('host') + '/' + this.getApiConfig('usersAPI') + '/' + this.getConfig('stage')
    );
  }

  getLocationServiceUrl(): any {
    return (
      this.getConfig('host') +
      '/' +
      this.getApiConfig('locationAPI') +
      '/' +
      this.getConfig('stage')
    );
  }

  getEnergySavingsUrl(): any {
    return (
      this.getConfig('host') +
      '/' +
      this.getApiConfig('energySavingsAPI') +
      '/' +
      this.getConfig('stage')
    );
  }

  /**
   * This method:
   *   a) Loads "env.json" to get the current working environment (e.g.: 'production', 'development')
   *   b) Loads "config.[env].json" to get all env's variables (e.g.: 'config.development.json')
   */
  public load() {
    return new Promise((resolve, reject) => {
      this.http
        .get('assets/env.json')
        .map(res => res.json())
        .catch(
          (error: any): any => {
            console.log('Configuration file "env.json" could not be read');
            resolve(true);
            return Observable.throw(error.json().error || 'Server error');
          }
        )
        .subscribe(envResponse => {
          this.env = envResponse;
          if (
            !(
              envResponse.env === 'production' ||
              envResponse.env === 'test' ||
              envResponse.env === 'test2' ||
              envResponse.env === 'development' ||
              envResponse.env === 'beta' ||
              envResponse.env === 'glenn' ||
              envResponse.env === 'ycy' ||
              envResponse.env === 'dev3' ||
              envResponse.env === 'dev4'
            )
          ) {
            console.error('Environment file is not set or invalid');
            return resolve(true);
          }
          this.http
            .get('assets/' + envResponse.env + '.json')
            .map(res => res.json())
            .catch((error: any) => {
              console.error('Error reading ' + envResponse.env + ' configuration file');
              resolve(error);
              return Observable.throw(error.json().error || 'Server error');
            })
            .subscribe(responseData => {
              this.config = responseData;

              this.http
                .get('assets/api-config.json')
                .map(res => res.json())
                .catch((error: any) => {
                  console.error('Error reading api-config.json configuration file:' + error);
                  resolve(error);
                  return Observable.throw(error.json().error || 'Server error');
                })
                .subscribe(apiConfigResponse => {
                  this.apiConfig = apiConfigResponse;
                  return resolve(true);
                });
            });
        });
    });
  }
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/core/config.service.ts